//@flow
import * as React from 'react';
import type { DataFormContainer$Props } from './flowTypes'

const renderSubmitButton=(props:DataFormContainer$Props)=>{
    const { pristine,submitting,isInvalidDoc,invalid } = (props:any);
    const submitOpenActionDialog = (props.submitOpenActionDialog:any)
    const kratos = (props.kratos:any)
    
    if (isInvalidDoc && Object.keys(kratos.formError).length == 0){
        return <button type="button" onClick={()=> submitOpenActionDialog()} className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit As Invalid Form</button>; 
    }else {
        return (
            <div>
                <button type="button" onClick={()=> submitOpenActionDialog()} 
                className="btn btn-primary btn-lg" disabled={pristine || submitting} >Submit Your Answer</button>
            </div>    
        )
    }
}

const SubmitButton=(props:DataFormContainer$Props)=>{
    return (
        <div className="row">
            <div className="col-sm">
                {renderSubmitButton(props)}
            </div>
        </div>   
    )
}

export default SubmitButton


// WEBPACK FOOTER //
// ./src/views/ProjectKratos/SubmitButton.js